/**
 * Each platform's own identity colour — the single exception to the warm
 * charcoal palette, used where a glyph has to read as *that* network rather
 * than as dashboard chrome.
 *
 * Lives beside `PlatformIcon` because it answers the same question: how a
 * platform presents itself. Keys are lower-case platform ids, as the API sends
 * them.
 */
const PLATFORM_ACCENT_COLOR: Record<string, string> = {
  instagram: '#E1306C',
  tiktok: '#111111',
};

/** Falls back to the neutral ink so an unknown platform still renders. */
export function platformAccentColor(platform: string): string {
  return PLATFORM_ACCENT_COLOR[platform.toLowerCase()] ?? 'dark';
}
